import { getDomainId } from 'api-client/helpers'
import { Tenant } from 'api-client/keystone.model'
import useListAction from 'core/hooks/useListAction'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { listAllDomainTenants } from './new-actions'
import { allDomainTenantsSelector } from './selectors'

const useTenantSelector = (selectedDomain: string = getDomainId()) => {
  const [data, setData] = useState<Array<Tenant>>([])

  // Fetch all tenants
  const { loading, reload } = useListAction(listAllDomainTenants)
  const allTenants = useSelector(allDomainTenantsSelector)

  // Filter tenants based on selected domain
  useEffect(() => {
    if (selectedDomain && !loading) {
      setData(allTenants?.filter((tenant) => tenant.domain_id === selectedDomain))
    }
  }, [selectedDomain, allTenants, loading])

  return {
    loading,
    reload,
    data,
  }
}

export default useTenantSelector
